import { Text } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

export const ContinueHelperText = () => (
    <Text className="text-center text-xs text-secondary-80">
        <FormattedMessage
            id="_.loan_summary.continue_helper_text_v21"
            defaultMessage='Before we can send funds to your account, we need you to complete a few final steps. Click "Continue" to get started.'
        />
    </Text>
);
